import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import Routes from './Routes'

import { Layout, MenuBuilder, AppbarMenuBuilder } from 'tr-components/Layout'
import { manageUrl, casLogoutUrl, imagesURL } from '../config/endpoints'
import AccountIcon from '@material-ui/icons/AccountCircle'
import { AppsIcon } from 'tr-components/AppsIcon'
import LanguageSupport from './LanguageSupport'
import { pathToMenu } from 'tr-components/Layout/pathToMenu'

export class App extends Component {
  state = {
    active: null
  }

  urlToItem = () => {
    const { module, submodule } = this.props.match.params
    let path = module && submodule ? `${module}/${submodule}` : module
    if (path === 'positions') path = 'positions/all'
    return pathToMenu(path, this.cachedMenu)
  }

  componentDidMount() {
    this.setState({
      active: this.urlToItem()
    })
    document.getElementById('favicon').href = imagesURL + '/icon/favicon-133x133.png'
  }

  //prettier-ignore
  cachedMenu = null
  getMenu = () => {
    const { permissions } = this.props
    if (this.cachedMenu == null) {
      let menu = new MenuBuilder().globalOnClick((active) => this.setState({ active }))

      if (permissions.has('CUSTOM_FIELDS_ALL')) {
        menu = menu
          .item('sidemenu.fields', 'Fields')
          .link(`/clients/${this.props.match.params.clientId}/fields`)
      }
      if (permissions.has('FORMS_ALL')) {
        menu = menu
          .item('sidemenu.forms', 'Forms')
          .link(`/clients/${this.props.match.params.clientId}/forms`)
      }
      if (permissions.has('POSITION_ALL')) {
        menu = menu.item('sidemenu.positions', 'Positions').submenus(
          new MenuBuilder()
            .item('sidemenu.positions,all', 'All Positions')
            .link(`/clients/${this.props.match.params.clientId}/positions/all`)
            .item('sidemenu.positions.categories', 'Categories')
            .link(`/clients/${this.props.match.params.clientId}/positions/categories`)
            // .item('sidemenu.positions.groups', 'Groups')
            //   .link(`/clients/${this.props.match.params.clientId}/positions/groups`)
            .build()
        )
      }
      this.cachedMenu = menu.build()
    }
    return this.cachedMenu
  }

  appbarMenu = [
    new AppbarMenuBuilder('Applications', <AppsIcon />, 'Applications')
      .item('appbar.items.manage', 'Manage')
      .externalLink(manageUrl)
      .build(),
    new AppbarMenuBuilder('Account', <AccountIcon />, 'Account')
      .item('appbar.items.signout', 'Logout')
      .externalLink(casLogoutUrl)
      .build()
  ]

  render() {
    return (
      <LanguageSupport>
        <Layout
          title={{ messageId: 'sidemenu.title', defaultMessage: 'Configure' }}
          menu={this.getMenu()}
          appbarMenus={this.appbarMenu}
          activeMenuItem={this.state.active}
          showLocaleSwitcher={false}
        >
          <Routes />
        </Layout>
      </LanguageSupport>
    )
  }
}

const mapStateToProps = (state) => ({
  clientId: state.user.clientId,
  permissions: state.user.permissions
})

export default withRouter(connect(mapStateToProps)(App))
export { mapStateToProps }



// WEBPACK FOOTER //
// ./src/containers/App.js